/**
 * The 偏旁 under the figure, each in the colour its strokes are drawn in.
 *
 * Apart from `bishun.ts`, which draws the character: this is the line that says
 * what the colours mean. 海 gives 氵 3 and 每 7, which is the same split the
 * 偏旁 row further down the block shows, counted.
 */

/**
 * The parts a character is written from, and how many strokes each takes.
 *
 * 海 gives 氵 with three and 每 with seven. A stroke the source could not
 * attribute is left out of the counting rather than given to a part, since a
 * count that is wrong is worse than a part that is short.
 */
export function partStrokeCounts(
  strokeParts: string,
  parts: readonly string[],
): readonly { readonly part: string; readonly strokes: number }[] {
  return parts.map((part, at) => ({
    part,
    strokes: Array.from(strokeParts).filter((one) => one === String(at)).length,
  }));
}

/** The parts and their stroke counts, as the line under the figure. */
export function writeLegend(
  legend: Element,
  strokeParts: string,
  parts: readonly string[],
): void {
  legend.replaceChildren();

  for (const [at, counted] of partStrokeCounts(strokeParts, parts).entries()) {
    const item = legend.ownerDocument.createElement("li");

    const written = legend.ownerDocument.createElement("span");

    /*
     * The part in the site's 汉字 face and the count in the page's own, the way
     * the 偏旁 row above sets them. The `lang` comes down from the list, which
     * the template gives the headword's.
     */
    written.className = "hanzi";
    written.textContent = counted.part;

    item.className = "cidian-bishun-legend-part";
    item.dataset["cbPart"] = String(at);
    item.append(written, ` ${String(counted.strokes)}`);

    /*
     * The count reads as a count rather than as a second character beside the
     * part. What is on the screen is 氵 3, which is as much as a row of three
     * parts has room for; what is read out is the sentence that is.
     */
    item.setAttribute(
      "aria-label",
      `${counted.part}, ${String(counted.strokes)} strokes`,
    );
    legend.append(item);
  }
}
